<template>
  <span>
    <span
      v-if="accounts.length === 1"
    >
      ({{ activeAccount.name }})
    </span>
    <span
      v-if="accounts.length > 1"
    >
      (<b-dropdown
        :text="activeAccount.name"
        variant="text"
        toggle-class="p-0"
      >
        <b-dropdown-item
          v-for="(account, index) in accounts"
          :key="index"
          :active="selected === account.id"
          @click="change(account.id)"
        >
          {{ account.name }}
        </b-dropdown-item>
      </b-dropdown>)
    </span>
  </span>
</template>
<script>
export default {
  props: {
    accounts: {
      type: Array,
      required: true
    },
    activeAccount: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selected: -1,
      previous: -1,
    }
  },
  computed: {
    options() {
      return this.accounts.map(account => ({
        value: account.id,
        text: account.name
      }))
    },
    accountName() {
      var selected = this.selected
      var found = this.accounts.find(account => {
        return account.id === selected
      })

      return found ? found.name : found
    }
  },
  watch: {
    selected(current, prev) {
      this.previous = prev
    }
  },
  mounted() {
    this.selected = this.activeAccount.id
  },
  methods: {
    change(id) {
      if(this.selected === id) {
        return
      }

      this.selected = id

      this.$bvModal.msgBoxConfirm(`Biztosan át szeretnél váltani a(z) ${this.accountName} fiókra?`, {
        title: 'Megerősítés',
        okVariant: 'success',
        okTitle: 'Igen',
        cancelTitle: 'Mégsem'
      }).then(value => {
        if(value) {
          this.$store.commit('enableLoading')

          this.$http.post(this.$url('api.accounts.switch'), { id: this.selected })
            .catch(() => {
              this.$bvToast.toast('Hiba történt a művelet végrehajtása közben!', {
                title: 'Hiba',
                variant: 'danger'
              })
            })
            .finally(() => window.location.reload())
        } else {
          this.selected = this.previous
        }
      })
    }
  }
}
</script>